module.exports = __webpack_public_path__ + "img/galeria-video-3.b9642e71.png";